import { render, staticRenderFns } from "./Estrusdetector.vue?vue&type=template&id=6fc5e213&scoped=true"
import script from "./Estrusdetector.vue?vue&type=script&lang=js"
export * from "./Estrusdetector.vue?vue&type=script&lang=js"
import style0 from "./Estrusdetector.vue?vue&type=style&index=0&id=6fc5e213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5e213",
  null
  
)

export default component.exports